import { TOfferType } from 'shared/types/api-models/offer-card/v1/get-offer-data';
type TooltipText = { title: string; description: string };

export const ROS_REESTR_TOOLTIP_TEXT: Record<TOfferType, TooltipText> = {
  flat: {
    title: 'Продавец указал кадастровый номер',
    description: 'В объявлении есть информация из Росреестра о собственности, обременениях и площади квартиры',
  },
  suburban: {
    title: 'Продавец указал кадастровый номер',
    description: 'В объявлении есть информация из Росреестра о собственности, статусе земли, площади дома и участка',
  },
  commercial: {
    title: '',
    description: '',
  },
};
